import { featuresItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              特色优势
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              为什么百万瓜友选择黑料718
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {featuresItems.map((item, i) => (
              <div
                key={i}
                className="flex flex-col items-center text-center p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/70 group"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-3 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}